import baseHttpService from "core/http/singleton/base";

import { BirthdayResItem } from "./resTypes";

import { getBirthdaysInMonthUrl, getListBirthdayUrl } from "./urls";

import { GetBirthdayParams, GetBirthdaysInMonthParams } from "./paramsTypes";

export const getListBirthdayAPI = async (
  payload: GetBirthdayParams
): Promise<BirthdayResItem[]> => {
  const { screenCode, ...params } = payload;
  const res = await baseHttpService.get<BirthdayResItem[]>(
    getListBirthdayUrl(screenCode),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getBirthdaysInMonthAPI = async (
  payload: GetBirthdaysInMonthParams
): Promise<BirthdayResItem[]> => {
  const { screenCode, month, year } = payload;
  const res = await baseHttpService.get<BirthdayResItem[]>(
    getBirthdaysInMonthUrl(screenCode, month, year)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
